/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../compat/compat.module';
import * as import2 from '@angular/common';
import * as import3 from 'ngx-cookie/src/cookie-options-provider';
import * as import4 from '../../app/@shared/auth/auth.service';
import * as import5 from '../../app/@shared/tracking/error-tracking.service';
import * as import6 from '../../app/@shared/tracking/custom-error-handler.service';
import * as import7 from '@angular/platform-browser';
import * as import8 from '@angular/platform-browser/animations';
import * as import9 from 'ngx-cookie/index';
import * as import10 from '../../app/@shared/auth/auth.module';
import * as import11 from '@angular/http';
import * as import12 from '@ngrx/store/src/ng2';
import * as import13 from '@ngrx/store-devtools/src/instrument';
import * as import14 from '../../app/@shared/datastore/datastore.module';
import * as import15 from '../../app/@shared/tracking/tracking.module';
import * as import16 from '@ngrx/store-devtools/src/extension';
import * as import17 from '@ngrx/store-devtools/src/devtools';
import * as import18 from '@ngrx/store/src/dispatcher';
import * as import19 from '../../app/@shared/datastore/api-http.service';
import * as import20 from '../../app/@shared/datastore/websocket/websocket';
import * as import21 from '../../app/@shared/datastore/datastore';
import * as import22 from '../../app/@shared/tracking/tracking.service';
import * as import23 from '../app/@shared/tracking/tracking.component.ngfactory';
import * as import24 from './compat.component.ngfactory';
import * as import25 from 'ngx-cookie/src/cookie.factory';
import * as import26 from '../../app/@shared/datastore/store';
import * as import27 from '../../app/@shared/tracking/tracking.component';
import * as import28 from '../../compat/compat-navigation.component';
import * as import29 from '../../app/@shared/auth/auth.config';
import * as import30 from 'ngx-cookie/src/cookie.service';
import * as import31 from '../../app/@shared/tracking/tracking.config';
import * as import32 from '@angular/animations/browser';
import * as import33 from '@ngrx/store/src/reducer';
import * as import34 from '@ngrx/store-devtools/src/config';
import * as import35 from '@ngrx/store/src/state';
import * as import36 from '@ngrx/store/src/store';
import * as import37 from '../../app/@shared/datastore/datastore.config';
import * as import38 from '@angular/router';
class CompatModuleInjector extends import0.ɵNgModuleInjector<import1.CompatModule> {
  _CommonModule_0:import2.CommonModule;
  _AUTH_CONFIG_1:any;
  _COOKIE_OPTIONS_2:any;
  _CookieOptionsProvider_3:import3.CookieOptionsProvider;
  _CookieService_4:any;
  _Auth_5:import4.Auth;
  _TRACKING_CONFIG_6:any;
  _ErrorTracking_7:import5.ErrorTracking;
  _ErrorHandler_8:import6.CustomErrorHandler;
  _APP_INITIALIZER_9:any[];
  _ApplicationInitStatus_10:import0.ApplicationInitStatus;
  _ɵf_11:import0.ɵf;
  _ApplicationRef_12:any;
  _ApplicationModule_13:import0.ApplicationModule;
  _BrowserModule_14:import7.BrowserModule;
  _BrowserAnimationsModule_15:import8.BrowserAnimationsModule;
  _CookieModule_16:import9.CookieModule;
  _AuthModule_17:import10.AuthModule;
  _HttpModule_18:import11.HttpModule;
  _StoreModule_19:import12.StoreModule;
  _StoreDevtoolsModule_20:import13.StoreDevtoolsModule;
  _DatastoreModule_21:import14.DatastoreModule;
  _TrackingModule_22:import15.TrackingModule;
  _CompatModule_23:import1.CompatModule;
  __LOCALE_ID_24:any;
  __NgLocalization_25:import2.NgLocaleLocalization;
  __Compiler_26:import0.Compiler;
  __APP_ID_27:any;
  __IterableDiffers_28:any;
  __KeyValueDiffers_29:any;
  __DomSanitizer_30:import7.ɵe;
  __Sanitizer_31:any;
  __HAMMER_GESTURE_CONFIG_32:import7.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_33:any[];
  __EventManager_34:import7.EventManager;
  __ɵDomSharedStylesHost_35:import7.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_36:import7.ɵDomRendererFactory2;
  __AnimationDriver_37:any;
  __ɵAnimationStyleNormalizer_38:any;
  __ɵAnimationEngine_39:import8.ɵa;
  __RendererFactory2_40:any;
  __ɵSharedStylesHost_41:any;
  __Testability_42:import0.Testability;
  __Meta_43:import7.Meta;
  __Title_44:import7.Title;
  __BrowserXhr_45:import11.BrowserXhr;
  __ResponseOptions_46:import11.BaseResponseOptions;
  __XSRFStrategy_47:import15.NoXSRFStrategy;
  __XHRBackend_48:import11.XHRBackend;
  __RequestOptions_49:import11.BaseRequestOptions;
  __Http_50:any;
  __REDUX_DEVTOOLS_EXTENSION_51:any;
  __DevtoolsExtension_52:import16.DevtoolsExtension;
  __DevtoolsDispatcher_53:import17.DevtoolsDispatcher;
  __Dispatcher_54:import18.Dispatcher;
  __INITIAL_REDUCER_55:any;
  __INITIAL_REDUCER_56:any;
  __Reducer_57:any;
  __INITIAL_STATE_58:any;
  __INITIAL_STATE_59:any;
  _INITIAL_OPTIONS_60:any;
  __STORE_DEVTOOLS_CONFIG_61:any;
  __StoreDevtools_62:import17.StoreDevtools;
  __State_63:any;
  __Store_64:any;
  _DATASTORE_CONFIG_65:any;
  __ApiHttp_66:import19.ApiHttp;
  __Store_67:any;
  __WebSocketService_68:import20.WebSocketService;
  __Datastore_69:import21.Datastore;
  __Tracking_70:import22.Tracking;
  __NgModuleFactoryLoader_71:import0.SystemJsNgModuleLoader;
  _ROUTES_72:any[];
  constructor(parent:import0.Injector) {
    super(parent,[
      import23.TrackingComponentNgFactory,
      import24.CompatComponentNgFactory
    ]
    ,[import24.CompatComponentNgFactory]);
  }
  get _LOCALE_ID_24():any {
    if ((this.__LOCALE_ID_24 == null)) { (this.__LOCALE_ID_24 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_24;
  }
  get _NgLocalization_25():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_25 == null)) { (this.__NgLocalization_25 = new import2.NgLocaleLocalization(this._LOCALE_ID_24)); }
    return this.__NgLocalization_25;
  }
  get _Compiler_26():import0.Compiler {
    if ((this.__Compiler_26 == null)) { (this.__Compiler_26 = new import0.Compiler()); }
    return this.__Compiler_26;
  }
  get _APP_ID_27():any {
    if ((this.__APP_ID_27 == null)) { (this.__APP_ID_27 = import0.ɵg()); }
    return this.__APP_ID_27;
  }
  get _IterableDiffers_28():any {
    if ((this.__IterableDiffers_28 == null)) { (this.__IterableDiffers_28 = import0.ɵl()); }
    return this.__IterableDiffers_28;
  }
  get _KeyValueDiffers_29():any {
    if ((this.__KeyValueDiffers_29 == null)) { (this.__KeyValueDiffers_29 = import0.ɵm()); }
    return this.__KeyValueDiffers_29;
  }
  get _DomSanitizer_30():import7.ɵe {
    if ((this.__DomSanitizer_30 == null)) { (this.__DomSanitizer_30 = new import7.ɵe(this.parent.get(import7.DOCUMENT))); }
    return this.__DomSanitizer_30;
  }
  get _Sanitizer_31():any {
    if ((this.__Sanitizer_31 == null)) { (this.__Sanitizer_31 = this._DomSanitizer_30); }
    return this.__Sanitizer_31;
  }
  get _HAMMER_GESTURE_CONFIG_32():import7.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_32 == null)) { (this.__HAMMER_GESTURE_CONFIG_32 = new import7.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_32;
  }
  get _EVENT_MANAGER_PLUGINS_33():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_33 == null)) { (this.__EVENT_MANAGER_PLUGINS_33 = [
      new import7.ɵDomEventsPlugin(this.parent.get(import7.DOCUMENT)),
      new import7.ɵKeyEventsPlugin(this.parent.get(import7.DOCUMENT)),
      new import7.ɵHammerGesturesPlugin(this.parent.get(import7.DOCUMENT),this._HAMMER_GESTURE_CONFIG_32)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_33;
  }
  get _EventManager_34():import7.EventManager {
    if ((this.__EventManager_34 == null)) { (this.__EventManager_34 = new import7.EventManager(this._EVENT_MANAGER_PLUGINS_33,this.parent.get(import0.NgZone))); }
    return this.__EventManager_34;
  }
  get _ɵDomSharedStylesHost_35():import7.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_35 == null)) { (this.__ɵDomSharedStylesHost_35 = new import7.ɵDomSharedStylesHost(this.parent.get(import7.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_35;
  }
  get _ɵDomRendererFactory2_36():import7.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_36 == null)) { (this.__ɵDomRendererFactory2_36 = new import7.ɵDomRendererFactory2(this._EventManager_34,this._ɵDomSharedStylesHost_35)); }
    return this.__ɵDomRendererFactory2_36;
  }
  get _AnimationDriver_37():any {
    if ((this.__AnimationDriver_37 == null)) { (this.__AnimationDriver_37 = import8.ɵb()); }
    return this.__AnimationDriver_37;
  }
  get _ɵAnimationStyleNormalizer_38():any {
    if ((this.__ɵAnimationStyleNormalizer_38 == null)) { (this.__ɵAnimationStyleNormalizer_38 = import8.ɵc()); }
    return this.__ɵAnimationStyleNormalizer_38;
  }
  get _ɵAnimationEngine_39():import8.ɵa {
    if ((this.__ɵAnimationEngine_39 == null)) { (this.__ɵAnimationEngine_39 = new import8.ɵa(this._AnimationDriver_37,this._ɵAnimationStyleNormalizer_38)); }
    return this.__ɵAnimationEngine_39;
  }
  get _RendererFactory2_40():any {
    if ((this.__RendererFactory2_40 == null)) { (this.__RendererFactory2_40 = import8.ɵd(this._ɵDomRendererFactory2_36,this._ɵAnimationEngine_39,this.parent.get(import0.NgZone))); }
    return this.__RendererFactory2_40;
  }
  get _ɵSharedStylesHost_41():any {
    if ((this.__ɵSharedStylesHost_41 == null)) { (this.__ɵSharedStylesHost_41 = this._ɵDomSharedStylesHost_35); }
    return this.__ɵSharedStylesHost_41;
  }
  get _Testability_42():import0.Testability {
    if ((this.__Testability_42 == null)) { (this.__Testability_42 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_42;
  }
  get _Meta_43():import7.Meta {
    if ((this.__Meta_43 == null)) { (this.__Meta_43 = new import7.Meta(this.parent.get(import7.DOCUMENT))); }
    return this.__Meta_43;
  }
  get _Title_44():import7.Title {
    if ((this.__Title_44 == null)) { (this.__Title_44 = new import7.Title(this.parent.get(import7.DOCUMENT))); }
    return this.__Title_44;
  }
  get _BrowserXhr_45():import11.BrowserXhr {
    if ((this.__BrowserXhr_45 == null)) { (this.__BrowserXhr_45 = new import11.BrowserXhr()); }
    return this.__BrowserXhr_45;
  }
  get _ResponseOptions_46():import11.BaseResponseOptions {
    if ((this.__ResponseOptions_46 == null)) { (this.__ResponseOptions_46 = new import11.BaseResponseOptions()); }
    return this.__ResponseOptions_46;
  }
  get _XSRFStrategy_47():import15.NoXSRFStrategy {
    if ((this.__XSRFStrategy_47 == null)) { (this.__XSRFStrategy_47 = new import15.NoXSRFStrategy()); }
    return this.__XSRFStrategy_47;
  }
  get _XHRBackend_48():import11.XHRBackend {
    if ((this.__XHRBackend_48 == null)) { (this.__XHRBackend_48 = new import11.XHRBackend(this._BrowserXhr_45,this._ResponseOptions_46,this._XSRFStrategy_47)); }
    return this.__XHRBackend_48;
  }
  get _RequestOptions_49():import11.BaseRequestOptions {
    if ((this.__RequestOptions_49 == null)) { (this.__RequestOptions_49 = new import11.BaseRequestOptions()); }
    return this.__RequestOptions_49;
  }
  get _Http_50():any {
    if ((this.__Http_50 == null)) { (this.__Http_50 = import11.ɵc(this._XHRBackend_48,this._RequestOptions_49)); }
    return this.__Http_50;
  }
  get _REDUX_DEVTOOLS_EXTENSION_51():any {
    if ((this.__REDUX_DEVTOOLS_EXTENSION_51 == null)) { (this.__REDUX_DEVTOOLS_EXTENSION_51 = import13._createReduxDevtoolsExtension()); }
    return this.__REDUX_DEVTOOLS_EXTENSION_51;
  }
  get _DevtoolsExtension_52():import16.DevtoolsExtension {
    if ((this.__DevtoolsExtension_52 == null)) { (this.__DevtoolsExtension_52 = new import16.DevtoolsExtension(this._REDUX_DEVTOOLS_EXTENSION_51)); }
    return this.__DevtoolsExtension_52;
  }
  get _DevtoolsDispatcher_53():import17.DevtoolsDispatcher {
    if ((this.__DevtoolsDispatcher_53 == null)) { (this.__DevtoolsDispatcher_53 = new import17.DevtoolsDispatcher()); }
    return this.__DevtoolsDispatcher_53;
  }
  get _Dispatcher_54():import18.Dispatcher {
    if ((this.__Dispatcher_54 == null)) { (this.__Dispatcher_54 = new import18.Dispatcher()); }
    return this.__Dispatcher_54;
  }
  get _INITIAL_REDUCER_56():any {
    if ((this.__INITIAL_REDUCER_56 == null)) { (this.__INITIAL_REDUCER_56 = import12._initialReducerFactory(this.__INITIAL_REDUCER_55)); }
    return this.__INITIAL_REDUCER_56;
  }
  get _Reducer_57():any {
    if ((this.__Reducer_57 == null)) { (this.__Reducer_57 = import13._createReducerIfExtension(this._REDUX_DEVTOOLS_EXTENSION_51,this,this._INITIAL_REDUCER_56)); }
    return this.__Reducer_57;
  }
  get _INITIAL_STATE_59():any {
    if ((this.__INITIAL_STATE_59 == null)) { (this.__INITIAL_STATE_59 = import12._initialStateFactory(this.__INITIAL_STATE_58,this._INITIAL_REDUCER_56)); }
    return this.__INITIAL_STATE_59;
  }
  get _STORE_DEVTOOLS_CONFIG_61():any {
    if ((this.__STORE_DEVTOOLS_CONFIG_61 == null)) { (this.__STORE_DEVTOOLS_CONFIG_61 = import13._createOptions(this._INITIAL_OPTIONS_60)); }
    return this.__STORE_DEVTOOLS_CONFIG_61;
  }
  get _StoreDevtools_62():import17.StoreDevtools {
    if ((this.__StoreDevtools_62 == null)) { (this.__StoreDevtools_62 = new import17.StoreDevtools(this._DevtoolsDispatcher_53,this._Dispatcher_54,this._Reducer_57,this._DevtoolsExtension_52,this._INITIAL_STATE_59,this._STORE_DEVTOOLS_CONFIG_61)); }
    return this.__StoreDevtools_62;
  }
  get _State_63():any {
    if ((this.__State_63 == null)) { (this.__State_63 = import13._createStateIfExtension(this._REDUX_DEVTOOLS_EXTENSION_51,this,this._INITIAL_STATE_59)); }
    return this.__State_63;
  }
  get _Store_64():any {
    if ((this.__Store_64 == null)) { (this.__Store_64 = import12._storeFactory(this._Dispatcher_54,this._Reducer_57,this._State_63)); }
    return this.__Store_64;
  }
  get _ApiHttp_66():import19.ApiHttp {
    if ((this.__ApiHttp_66 == null)) { (this.__ApiHttp_66 = new import19.ApiHttp(this._XHRBackend_48,this._RequestOptions_49,this._Auth_5,this._DATASTORE_CONFIG_65)); }
    return this.__ApiHttp_66;
  }
  get _Store_67():any {
    if ((this.__Store_67 == null)) { (this.__Store_67 = import12._storeFactory(this._Dispatcher_54,this._Reducer_57,this._State_63)); }
    return this.__Store_67;
  }
  get _WebSocketService_68():import20.WebSocketService {
    if ((this.__WebSocketService_68 == null)) { (this.__WebSocketService_68 = new import20.WebSocketService(this._DATASTORE_CONFIG_65,this._Auth_5,this._Store_67)); }
    return this.__WebSocketService_68;
  }
  get _Datastore_69():import21.Datastore {
    if ((this.__Datastore_69 == null)) { (this.__Datastore_69 = new import21.Datastore(this._Store_67,this._ApiHttp_66,this._WebSocketService_68)); }
    return this.__Datastore_69;
  }
  get _Tracking_70():import22.Tracking {
    if ((this.__Tracking_70 == null)) { (this.__Tracking_70 = new import22.Tracking(this._Http_50,this._Auth_5,this._CookieService_4,this._TRACKING_CONFIG_6)); }
    return this.__Tracking_70;
  }
  get _NgModuleFactoryLoader_71():import0.SystemJsNgModuleLoader {
    if ((this.__NgModuleFactoryLoader_71 == null)) { (this.__NgModuleFactoryLoader_71 = new import0.SystemJsNgModuleLoader(this._Compiler_26,this.parent.get(import0.SystemJsNgModuleLoaderConfig,(null as any)))); }
    return this.__NgModuleFactoryLoader_71;
  }
  createInternal():import1.CompatModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._AUTH_CONFIG_1 = {
      baseUrl: 'https://www.freelancer.com/auth',
      authHashCookie: 'GETAFREE_AUTH_HASH_V2',
      userIdCookie: 'GETAFREE_USER_ID'
    }
    ;
    this._COOKIE_OPTIONS_2 = {};
    this._CookieOptionsProvider_3 = new import3.CookieOptionsProvider(this._COOKIE_OPTIONS_2,this);
    this._CookieService_4 = import25.cookieServiceFactory(this._CookieOptionsProvider_3);
    this._Auth_5 = new import4.Auth(this._AUTH_CONFIG_1,this._CookieService_4);
    this._TRACKING_CONFIG_6 = {
      trackingEndpoint: 'https://t.freelancer.com/0px.gif',
      sessionCookie: '_tracking_session',
      navigationPerformanceSamplingRate: 1,
      enableErrorTracking: true,
      sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
      gitRevision: 'e9c619d8691',
      buildDate: 'Fri Jun 09 2017 06:58:15 GMT-0400 (EDT)'
    }
    ;
    this._ErrorTracking_7 = new import5.ErrorTracking(this._Auth_5,this._TRACKING_CONFIG_6);
    this._ErrorHandler_8 = new import6.CustomErrorHandler(this._ErrorTracking_7);
    this._APP_INITIALIZER_9 = [
      import0.ɵo,
      import7.ɵc(this.parent.get(import7.NgProbeToken,(null as any)),this.parent.get(import0.NgProbeToken,(null as any)))
    ]
    ;
    this._ApplicationInitStatus_10 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_9);
    this._ɵf_11 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_8,this.componentFactoryResolver,this._ApplicationInitStatus_10);
    this._ApplicationRef_12 = this._ɵf_11;
    this._ApplicationModule_13 = new import0.ApplicationModule(this._ApplicationRef_12);
    this._BrowserModule_14 = new import7.BrowserModule(this.parent.get(import7.BrowserModule,(null as any)));
    this._BrowserAnimationsModule_15 = new import8.BrowserAnimationsModule();
    this._CookieModule_16 = new import9.CookieModule();
    this._AuthModule_17 = new import10.AuthModule();
    this._HttpModule_18 = new import11.HttpModule();
    this._StoreModule_19 = new import12.StoreModule();
    this._StoreDevtoolsModule_20 = new import13.StoreDevtoolsModule();
    this._DatastoreModule_21 = new import14.DatastoreModule();
    this._TrackingModule_22 = new import15.TrackingModule();
    this._CompatModule_23 = new import1.CompatModule();
    this.__INITIAL_REDUCER_55 = import26.store;
    this.__INITIAL_STATE_58 = (undefined as any);
    this._INITIAL_OPTIONS_60 = {maxAge: 5};
    this._DATASTORE_CONFIG_65 = {
      apiBaseUrl: 'https://www.freelancer.com/api',
      ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
      webSocketUrl: 'https://notifications.freelancer.com'
    }
    ;
      this._ROUTES_72 = [[
        {
          selector: 'webapp-compat-tracking',
          loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
          component: import27.TrackingComponent,
          path: 'hack_path_not_used'
        }
        ,
        {
          selector: 'webapp-compat-navigation',
          loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
          component: import28.CompatNavigationComponent,
          path: 'hack_path_not_used'
        }

      ]
    ];
    return this._CompatModule_23;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import29.AUTH_CONFIG)) { return this._AUTH_CONFIG_1; }
    if ((token === import3.COOKIE_OPTIONS)) { return this._COOKIE_OPTIONS_2; }
    if ((token === import3.CookieOptionsProvider)) { return this._CookieOptionsProvider_3; }
    if ((token === import30.CookieService)) { return this._CookieService_4; }
    if ((token === import4.Auth)) { return this._Auth_5; }
    if ((token === import31.TRACKING_CONFIG)) { return this._TRACKING_CONFIG_6; }
    if ((token === import5.ErrorTracking)) { return this._ErrorTracking_7; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_8; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_9; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_10; }
    if ((token === import0.ɵf)) { return this._ɵf_11; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_12; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_13; }
    if ((token === import7.BrowserModule)) { return this._BrowserModule_14; }
    if ((token === import8.BrowserAnimationsModule)) { return this._BrowserAnimationsModule_15; }
    if ((token === import9.CookieModule)) { return this._CookieModule_16; }
    if ((token === import10.AuthModule)) { return this._AuthModule_17; }
    if ((token === import11.HttpModule)) { return this._HttpModule_18; }
    if ((token === import12.StoreModule)) { return this._StoreModule_19; }
    if ((token === import13.StoreDevtoolsModule)) { return this._StoreDevtoolsModule_20; }
    if ((token === import14.DatastoreModule)) { return this._DatastoreModule_21; }
    if ((token === import15.TrackingModule)) { return this._TrackingModule_22; }
    if ((token === import1.CompatModule)) { return this._CompatModule_23; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_24; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_25; }
    if ((token === import0.Compiler)) { return this._Compiler_26; }
    if ((token === import0.APP_ID)) { return this._APP_ID_27; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_28; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_29; }
    if ((token === import7.DomSanitizer)) { return this._DomSanitizer_30; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_31; }
    if ((token === import7.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_32; }
    if ((token === import7.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_33; }
    if ((token === import7.EventManager)) { return this._EventManager_34; }
    if ((token === import7.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_35; }
    if ((token === import7.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_36; }
    if ((token === import32.AnimationDriver)) { return this._AnimationDriver_37; }
    if ((token === import32.ɵAnimationStyleNormalizer)) { return this._ɵAnimationStyleNormalizer_38; }
    if ((token === import32.ɵAnimationEngine)) { return this._ɵAnimationEngine_39; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_40; }
    if ((token === import7.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_41; }
    if ((token === import0.Testability)) { return this._Testability_42; }
    if ((token === import7.Meta)) { return this._Meta_43; }
    if ((token === import7.Title)) { return this._Title_44; }
    if ((token === import11.BrowserXhr)) { return this._BrowserXhr_45; }
    if ((token === import11.ResponseOptions)) { return this._ResponseOptions_46; }
    if ((token === import11.XSRFStrategy)) { return this._XSRFStrategy_47; }
    if ((token === import11.XHRBackend)) { return this._XHRBackend_48; }
    if ((token === import11.RequestOptions)) { return this._RequestOptions_49; }
    if ((token === import11.Http)) { return this._Http_50; }
    if ((token === import16.REDUX_DEVTOOLS_EXTENSION)) { return this._REDUX_DEVTOOLS_EXTENSION_51; }
    if ((token === import16.DevtoolsExtension)) { return this._DevtoolsExtension_52; }
    if ((token === import17.DevtoolsDispatcher)) { return this._DevtoolsDispatcher_53; }
    if ((token === import18.Dispatcher)) { return this._Dispatcher_54; }
    if ((token === import12._INITIAL_REDUCER)) { return this.__INITIAL_REDUCER_55; }
    if ((token === import12.INITIAL_REDUCER)) { return this._INITIAL_REDUCER_56; }
    if ((token === import33.Reducer)) { return this._Reducer_57; }
    if ((token === import12._INITIAL_STATE)) { return this.__INITIAL_STATE_58; }
    if ((token === import12.INITIAL_STATE)) { return this._INITIAL_STATE_59; }
    if ((token === import34.INITIAL_OPTIONS)) { return this._INITIAL_OPTIONS_60; }
    if ((token === import34.STORE_DEVTOOLS_CONFIG)) { return this._STORE_DEVTOOLS_CONFIG_61; }
    if ((token === import17.StoreDevtools)) { return this._StoreDevtools_62; }
    if ((token === import35.State)) { return this._State_63; }
    if ((token === import36.Store)) { return this._Store_64; }
    if ((token === import37.DATASTORE_CONFIG)) { return this._DATASTORE_CONFIG_65; }
    if ((token === import19.ApiHttp)) { return this._ApiHttp_66; }
    if ((token === import26.Store)) { return this._Store_67; }
    if ((token === import20.WebSocketService)) { return this._WebSocketService_68; }
    if ((token === import21.Datastore)) { return this._Datastore_69; }
    if ((token === import22.Tracking)) { return this._Tracking_70; }
    if ((token === import0.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_71; }
    if ((token === import38.ROUTES)) { return this._ROUTES_72; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_11.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_35 && this._ɵDomSharedStylesHost_35.ngOnDestroy());
  }
}
export const CompatModuleNgFactory:import0.NgModuleFactory<import1.CompatModule> = new import0.NgModuleFactory<any>(CompatModuleInjector,import1.CompatModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0Lm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/compat/compat.module.ngfactory.ts